$ = require 'jquery'
pluginChromeTemplate = require 'views/templates/plugin_chrome'
PluginView = require 'views/plugin/plugin-view'

module.exports = class PluginChromeView extends PluginView
  initialize: ({ @content }) ->
    @retain(@content)

  renderOnce: ->
    @$el.html(pluginChromeTemplate(@content))
    @initIFrames(@model)
    @

  close: ->
    @content.callback?()
    @isRemoved = true
    @remove()



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-chrome-view.coffee